import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor() { /* empty */ }

  error(component: string, info: any) {
    console.error('Error from : ' + component, info);
  }

  warning(component: string, info: any) {
    console.warn('Warning from : ' + component, info);
  }

  info(component: string, info: any) {
    console.log('Info from : ' + component, info);
  }
}
